export type LocaleCode = "en" | "he" | "th";
export type Direction = "ltr" | "rtl";

export interface LocaleDefinition {
    code: LocaleCode;
    intlLocale: string;
    nativeName: string;
    shortLabel: string;
    direction: Direction;
}

/** Canonical locale registry used by routing, Intl formatting, and direction. */
export const LOCALES: Record<LocaleCode, LocaleDefinition> = {
    en: { code: "en", intlLocale: "en-US", nativeName: "English", shortLabel: "EN", direction: "ltr" },
    he: { code: "he", intlLocale: "he-IL", nativeName: "עברית", shortLabel: "HE", direction: "rtl" },
    th: { code: "th", intlLocale: "th-TH", nativeName: "ไทย", shortLabel: "TH", direction: "ltr" }
};

export const SUPPORTED_LOCALES = Object.keys(LOCALES) as LocaleCode[];

export function getLocaleDefinition(code: LocaleCode): LocaleDefinition {
    return LOCALES[code];
}
